var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMediaStreamAPISupported)?_c('div',[_vm._v(_vm._s(_vm.mediaNotSupportedMessage))]):_vm._e(),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewport scanner",attrs:{"id":"interactive"}},[_c('video'),_vm._v(" "),_c('canvas',{staticClass:"drawingBuffer"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe7395b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./EcomCore/Components/InputDevices/QuaggaJsBarcodeScanner.vue
// module id = 58
// module chunks = 0